export default commomImport => [{
  path: `info-manager`,
  name: 'InfoManager',
  meta: {
    title: 'store.infoManager'
  },
  //  全部订单
  component: commomImport('store-manager/info-manager')
}];
